















































import { Component, Vue, Prop } from "vue-property-decorator"
import { STATUSES as BOOKING_CANDIDATE_STATUSES } from "@/constants/booking_candidate"
import { mapState } from "vuex"
import QDownloadBtn from "@/components/QDownloadBtn.vue"

@Component({
  components: {
    QDownloadBtn,
  },
  computed: {
    ...mapState({
      loading: "loading",
    }),
    ...mapState("QuestionnaireAnswer", {
      questionnaireAnswer: "questionnaireAnswer",
    }),
  },
})
export default class BookingCandidateListItem extends Vue {
  @Prop({ default: () => ({}) }) bookingCandidate!: BookingCandidate
  bookingCandidateStatuses = BOOKING_CANDIDATE_STATUSES

  questionnaireAnswer!: Model

  get name() {
    if (!this.bookingCandidate.first_name && !this.bookingCandidate.last_name) {
      return null
    }
    return (
      (this.bookingCandidate.first_name ?? "") +
      " " +
      (this.bookingCandidate.last_name ?? "")
    )
  }

  toRead(oid) {
    this.$router.push({
      name: "candidate-booking-candidate-read",
      params: {
        bookingCandidateOid: oid,
      },
    })
  }

  toDownloadReport() {
    return this.$store
      .dispatch("BookingCandidate/fetch", this.bookingCandidate.object_id)
      .then(async (response) => {
        const bookingCandidate = response.data.data

        return await this.$store
          .dispatch(
            "QuestionnaireAnswer/downloadReport",
            bookingCandidate.questionnaire_answer.object_id
          )
          .then((response) => {
            const blob = new Blob([response.data], { type: "application/pdf" })
            const link = document.createElement("a")
            link.href = URL.createObjectURL(blob)
            link.download = "Quescreen Report - " + this.name
            link.click()
          })
      })
  }
}
